<div class="custom-tabs">
  @for (tab of tabs; track tab.value; let i = $index) {
  <div
    (click)="selectTab(tab)"
    [class.active]="selectedTab?.value === tab.value"
    [class.disabled]="tab.isDisabled"
    [matTooltip]="tab.isDisabled ? tab.tooltip : ''"
    class="custom-tab border-right"
    [attr.data-cy]="tab.name"
  >
    @if (tab.icon) {
    <mat-icon>{{ tab.icon }}</mat-icon>
    }
    {{ tab.name | translate }}
  </div>
  }
</div>
